import { ApiService } from '../../../base/services/data/api.service';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { VehiclesModel } from '../../../models/lookup-tables/resources/vehicles.model';

@Injectable()
export class VehiclesLookupService {
    public error: any;
    public hasError: boolean;
    constructor(public apiService: ApiService) {
    }
    public getActiveVehicles(): Observable<VehiclesModel[]> {
        return this.apiService.get<VehiclesModel[]>(`api/VehiclesLookup/GetActiveVehiclesList`).pipe(
            catchError(error => this.handleError(error))
        );
    }

    private handleError(error: HttpErrorResponse) {
        this.hasError = true;
        return throwError(() => error);
    }
}